import useSWR from 'swr';

import apiRequest from '@/services/apiRequest';
import { getSearchApi } from '@/utility/getCoreApi';

type TGeoDataMyIpResponse = {
  lat: number;
  lng: number;
  city: string;
  state: string;
  country_code: string;
  country_name: string;
};

// Geo IP data does not change during a session, so we default to cache-first behavior.
// Once fetched, the response is reused across all consumers without re-requesting.
export const useGeoDataMyIp = (
  skip?: boolean,
  revalidateIfStale = false,
  revalidateOnFocus = false,
  revalidateOnReconnect = false,
) => {
  return useSWR(
    skip ? null : `${getSearchApi()}/geodata/my-ip`,
    (url: string) => apiRequest<TGeoDataMyIpResponse>({ url }),
    { revalidateIfStale, revalidateOnFocus, revalidateOnReconnect },
  );
};
